import React from 'react'

import {
  InsurancePayerSelectionUI,
  InsurancePayerOption,
} from '~/components/screens/InsurancePayerSelectionUI'
import { useBffWebOnboardingInsurancePayerSelection, usePayers } from '../utils'
import { BenefitAdministrationType } from '~/utils/constants'

/**
 * Authenticated insurance payer selection screen.
 * Reuses InsurancePayerSelectionUI component and calls BFF endpoint to select and save insurance payer.
 */
const AuthenticatedInsurancePayerSelection: React.FC = () => {
  const { data: payers = [], isLoading: payersLoading } = usePayers(
    BenefitAdministrationType.EXTERNAL,
  )
  const payerSelection = useBffWebOnboardingInsurancePayerSelection()

  const handleSubmit = async (payer: InsurancePayerOption | null) => {
    // Pass payer.id if payer exists, otherwise pass null for "no insurance"
    await payerSelection.handler(payer ? payer.id : null)
  }

  return (
    <InsurancePayerSelectionUI
      payers={payers}
      isLoading={payersLoading || payerSelection.loading}
      onSubmit={handleSubmit}
    />
  )
}

export default AuthenticatedInsurancePayerSelection
